import dayjs from 'dayjs';
import dateTimeFormat from './DateTime';
import { ASSESSMENTS } from 'chameleon/ui-stack/utilities/copy';

const NOW_OPEN = ASSESSMENTS.NOW_OPEN;
const isOpen = (a) => a.status === 'opened';
export const DASH = '—';

/**
 * Outputs formatted Date with a fallback
 * @param {object} a - Assignment object
 * @param {string} preset - formatting preset
 * @param {string} fallback - fallback text, when date is not present.
 * @param {boolean} isStudent - if start date is present and passed the current date - change it to be 'Now Open'
 */
export function assignmentStartDate(
  a,
  preset,
  fallback = DASH,
  isStudent = false,
  nowOpenLabel = NOW_OPEN,
) {
  if (!a) return fallback;

  /* in some cases we have old results which don't have a starts_at date. Ideally starts_at is always present */
  const startsAtDate = a.starts_at || a.startsAt;

  if (!startsAtDate && !a.opened) {
    return fallback;
  }
  const formattedStartDate = dateTimeFormat(startsAtDate, preset, a.timezone);
  const formattedOpenedDate = a.opened
    ? dateTimeFormat(a.opened, preset, a.timezone)
    : fallback;
  const date = startsAtDate ? formattedStartDate : formattedOpenedDate;

  return isStudent && isOpen(a) ? nowOpenLabel : date;
}

/**
 * Outputs formatted Date with a fallback
 * @param {object} a - Assignment object
 * @param {string} preset - formatting preset
 * @param {string} fallback - fallback text, when date is not present.
 * @param {boolean} isStudent - if start date is present and passed the current date - change it to be 'Now Open'
 */
export function assignmentDueDate(
  a,
  preset = 'date',
  fallback = DASH,
  isStudent = false,
  nowOpenLabel = NOW_OPEN,
) {
  if (!a) return fallback;

  /* in some cases we have old results which don't have a due_at date. Ideally it is always present */
  const dueAtDate = a.due_at || a.dueAt;

  if (!dueAtDate && !a.closed) {
    return isStudent && isOpen(a) ? nowOpenLabel : fallback;
  }

  if (!dueAtDate && a.closed) return fallback;

  const formattedDueDate = dateTimeFormat(dueAtDate, preset, a.timezone);
  const formattedClosedDate =
    isOpen(a) && isStudent
      ? nowOpenLabel
      : dateTimeFormat(a.closed, preset, a.timezone);
  const date = a.closed ? formattedClosedDate : fallback;
  return dueAtDate ? formattedDueDate : date;
}

// For preap final exams, the due_at date is acually displayed on the first row (the part 1 row)
// the due_at date is the start_date from part 2, plus the alotted time for the exam.
export function getRelatedAssignmentDueAtDate(relatedAssignment) {
  const startDate = relatedAssignment && relatedAssignment.starts_at;
  const relatedAssignmentTime =
    startDate &&
    relatedAssignment.timer &&
    parseInt(relatedAssignment.timer, 10);
  return startDate
    ? dayjs(startDate).add(relatedAssignmentTime, 'minute')
    : null;
}

export function dateIsSet(formattedDate, fallback = DASH) {
  return formattedDate !== fallback;
}
